import { render, staticRenderFns } from "./IconChatBubble.vue?vue&type=template&id=855f08aa"
import script from "./IconChatBubble.vue?vue&type=script&lang=js"
export * from "./IconChatBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports